<template>
	<v-container class="pt-6 mb-16">
		<v-row>
      <!-- Grupos asignados -->
			<v-col cols="12" sm="6"  md="6" lg="4" v-for="( acceso, i ) in accesos" :key="i">
			  <v-card class="mx-auto shadowCard">
			  	<v-card-text>
	  				<v-row>
	  					<v-col cols="9">
	  						<div>
			            <h5 class="mb-0 text-h6" >
			             	{{ acceso.vendedora }}
			            </h5>

			            <p class="mb-0 font-weight-bold">
			           		<span class="primary--text">{{ acceso.plantel }}</span> <br/>
			              Hora: {{ acceso.hora_inicio }} <br/>
			              Registró: {{ acceso.registro }} <br/>
			              <span class="green--text" v-if="acceso.retraso == 'Sin retraso'">{{ acceso.retraso }}</span>
			              <span class="red--text"   v-else-if="acceso.retraso > 0">Retraso de {{ acceso.retraso }} min</span>
			              <span v-else>Retraso:</span>
			            </p>
			          </div>
	  					</v-col>

	  					<v-col cols="3" class="px-0">
		            <v-avatar
			            size="75"
			            color="transparent"
			            rounded
			            :class="acceso.escuela == 1 ? 'sucursal_inbi' : 'sucursal_fast'"
			          >
			            <v-img src="@/assets/fondos/logo_blanco.png" contain v-if="acceso.escuela == 1"></v-img>
			            <v-img src="@/assets/fondos/logo_fast.png"   contain v-else></v-img>
			          </v-avatar>
	  					</v-col>
	  				</v-row>
	  			</v-card-text>
          <v-card-actions class="pt-0 pl-2 pb-0">
            <p class="pl-2 font-weight-bold">
              <v-chip v-if="acceso.asistencia" small dark class="mr-1 green">
                Sucursal abierta
              </v-chip>

              <v-chip v-else-if="acceso.retraso" small dark class="mr-1 red">
                Sucursal cerrada
              </v-chip>

              <v-chip v-else small dark class="mr-1 grey">
                Sucursal cerrada
              </v-chip>
            </p>
          </v-card-actions>
			  </v-card>
			</v-col>
    </v-row>

    <!-- Alertas -->
    <Alerta      v-if="respuestaAlerta" :parametros="parametros"/>
    <Loader      v-if="cargar"          :loader="loader"/>

	</v-container>
</template>
<script>
	// Importar lebrerías
	import { mapGetters, mapActions } from 'vuex'
  const  base64 = require('base-64');

	// Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'

  export default {

  	props:['accesos'],

  	components:{
  		Alerta,
      Loader,
  	},

    data () {
      return {
        parametros:{
          dialogError: false,
          mensaje: '',
          color: ''
        },

	     	respuestaAlerta:false,
        loader: true,
        cargar: false,
      }
    },

    computed:{
      ...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getGrupos', 'getEscuela' ]),
    },


    methods:{
    	...mapActions( 'login', [ 'abrirGrupo', 'grabarGruposUsuario', 'salirLogin' ]),

    	verGrupo( acceso ){
        this.cargar = true
    		this.abrirGrupo( acceso ).then(response => { 
          this.cargar = false 
        }).catch( error =>{
          this.validarError ( error )
    		}).finally(()=>{ this.cargar = false })
    	},

    }
  }
</script>
<style scoped>
  .sucursal_inbi{
    background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
  }  

  .sucursal_fast{
   	background: rgb(130,0,0);
		background: linear-gradient(90deg, rgba(130,0,0,1) 0%, rgba(255,0,0,1) 100%);
  }  
</style>